import React, { FC } from 'react';
import { scaleOP } from '@components/frame';
import { fontOP } from '@styles/fonts';
import { DOC_TYPE, KEYS_TAGS, TAG_KEYS } from '@components/imageHandling/common';
import { useSelector } from 'react-redux';
import { tabUpdaters } from '@components/operatorPanel/components/OperatorPanelInformation/OperatorPanelInformationTabs/constants';
import { OP_DOCUMENTS_DISPLAY_MODE, OPERATOR_PANEL_INFORMATION_SCREENS } from '@components/operatorPanel/constants/operatorPanel.constants';
import OperatorPanelInformationDocumentsDifferentModes from './OperatorPanelInformationDocuments/OperatorPanelInformationDocumentsDifferentModes';
import i18n from 'i18n-js';
import { useRoute } from '@react-navigation/native';
import { selectCurrentContextImagesDocuments, selectCurrentContextLoading } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

interface OperatorPanelInformationSetupScreenProps {}

const OperatorPanelInformationSetupScreen: FC<OperatorPanelInformationSetupScreenProps> = () => {
  const route = useRoute();

  const imagesDocuments = useSelector(selectCurrentContextImagesDocuments);
  const imagesDocumentsLoading = useSelector(selectCurrentContextLoading);
  const images = tabUpdaters[OPERATOR_PANEL_INFORMATION_SCREENS.Setup]?.getDataFromImages?.(imagesDocuments) ?? [];

  const noResult = images?.length === 0 && !imagesDocumentsLoading;
  const isTileMode = route.params?.mode === OP_DOCUMENTS_DISPLAY_MODE.TILE;
  const title = !isTileMode ? i18n.t(DOC_TYPE.SETUP_SHEET) : i18n.t('Setup Sheets');

  return (
    <OperatorPanelInformationDocumentsDifferentModes
      {...{
        images,
        noResult,
        title,
        font: fontOP,
        scale: scaleOP,
        scopeIdsForDefaultLinking: [KEYS_TAGS.NcFile as keyof typeof TAG_KEYS],
        documentTypeForDefaultLinking: DOC_TYPE.SETUP_SHEET,
        testID: TEST_IDS.operatorPanel.information.setup.root,
      }}
    />
  );
};

export default OperatorPanelInformationSetupScreen;
